/**
 * 檔案用途區塊
 * @module ThirdPartyProvider
 * @purpose 定義系統支援的第三方登入供應商代碼列舉，供登入流程與身分驗證模組共用。
 * @external https://innotech.atlassian.net/browse/IN-132134
 * @external https://innotech.atlassian.net/browse/IN-113493
 * @external https://innotech.atlassian.net/browse/IN-111885
 * @external https://innotech.atlassian.net/browse/IN-89368
 * @external https://innotech.atlassian.net/browse/IN-46601
 */

/**
 * 宣告內容用途說明與單號關聯
 * @description 第三方登入供應商列舉，將外部平台名稱映射為系統內部固定識別值。
 * @purpose 統一 Apple、Google、Facebook、Zalo、Telegram、WalletConnect 等登入來源的代碼表示，避免跨模組字串不一致。
 */
export enum ThirdPartyProvider {
  Apple = 'apple',
  Google = 'google',
  FaceBook = 'fb',
  Zalo = 'zalo',
  Telegram = 'telegram',
  WalletConnect = 'walletconnect',
  Passkey = 'passkey',
}

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:22:12.581Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note Added required three-section annotations (top/middle/bottom) in JSDoc format, kept enum runtime logic unchanged, mapped file history subjects to top-level @external Jira URLs, and omitted declaration-level @external because declarationOrigins is empty.
 */
